import React, { createContext, useContext, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useHistory, useLocation } from 'react-router-dom';
import ApolloClientSellerService from 'ApolloClientSellerService';
import LoadingPersist from 'components/loading/LoadingPersist';
import { GET_SECURITY_STATUS } from 'views/catalog/actions/userActions';
import { DEFAULT_PATHS } from 'config';

const SecurityStatusContext = createContext({});

// Status of the login security checks (OTP, password expiry) for components
// rendered inside SecurityGuard, e.g. the password expiry banner.
export const useSecurityStatus = () => useContext(SecurityStatusContext);

// Sends users with a pending OTP or an expired password to the security check
// page before rendering the protected screens. The backend enforces the same
// rule, so if the status can't be read we render and let the API decide.
const SecurityGuard = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const { data, loading } = useQuery(GET_SECURITY_STATUS(), {
    client: ApolloClientSellerService,
    fetchPolicy: 'network-only',
  });
  const status = data?.getUserDetail || {};
  const checkRequired = !!(status.otpVerificationRequired || status.passwordChangeRequired);

  useEffect(() => {
    if (checkRequired) {
      history.replace({
        pathname: DEFAULT_PATHS.SECURITY_CHECK,
        state: { from: { pathname: location.pathname, search: location.search, state: location.state } },
      });
    }
  }, [checkRequired]);

  if (loading || checkRequired) {
    return <LoadingPersist isLoading />;
  }
  return <SecurityStatusContext.Provider value={status}>{children}</SecurityStatusContext.Provider>;
};

export default SecurityGuard;
